import {UserType} from './user-type.model';
import {PermissionScreen} from './permission-screen.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from './user';
import {Permission} from './permission.model';

export class UserPermission {
  id: string;
  active: boolean;
  create: boolean;
  update: boolean;
  read: boolean;
  delete: boolean;
  permission: Permission;

  form: FormGroup;

  constructor(other?: any) {
    if (other) {
      this.id = other.id;
      this.active = other.active;
      this.create = other.create;
      this.update = other.update;
      this.read = other.read;
      this.delete = other.delete;
      this.permission = other.permission;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        active: new FormControl(this.active, [Validators.required]),
        create: new FormControl(this.create, [Validators.required]),
        update: new FormControl(this.update, [Validators.required]),
        read: new FormControl(this.read, [Validators.required]),
        delete: new FormControl(this.delete, [Validators.required]),
      });
    }
    return this.form;
  }

  updateForm(other) {
    this.form.patchValue(other);
  }
}
